"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentStepperContext = void 0;
/* A component for i.e. mobile menu pages that allows the user to navigate multiple steps */
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var margin_1 = __importDefault(require("../Utils/margin"));
var padding_1 = __importDefault(require("../Utils/padding"));
var ContentStepperWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n"], ["\n  ", "\n  ", "\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n"])), margin_1.default, padding_1.default);
var AnimationDirection;
(function (AnimationDirection) {
    AnimationDirection["NEXT"] = "next";
    AnimationDirection["PREV"] = "prev";
})(AnimationDirection || (AnimationDirection = {}));
var ContentPages = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: start;\n  display: flex;\n  flex-wrap: nowrap;\n  height: 100%;\n  margin-left: -100%;\n  width: 300%;\n  ", "\n"], ["\n  align-items: start;\n  display: flex;\n  flex-wrap: nowrap;\n  height: 100%;\n  margin-left: -100%;\n  width: 300%;\n  ", "\n"])), function (props) { return "\n    ".concat(props.$direction &&
    "\n    margin-left: ".concat(props.$direction === AnimationDirection.NEXT ? '-200%' : '0%', ";\n    transition: all ").concat(props.$speed / 1000, "s ease-in-out;\n    "), "\n  "); });
var SlidePage = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: calc(100% / 3);\n"], ["\n  width: calc(100% / 3);\n"])));
exports.ContentStepperContext = React.createContext({});
var ContentStepper = function (_a) {
    var children = _a.children, _b = _a.speed, speed = _b === void 0 ? 250 : _b, props = __rest(_a, ["children", "speed"]);
    var _c = React.useState([]), history = _c[0], setHistory = _c[1];
    var _d = React.useState(children), currentItem = _d[0], setCurrentItem = _d[1];
    var _e = React.useState(), nextItem = _e[0], setNextItem = _e[1];
    var _f = React.useState(), prevItem = _f[0], setPrevItem = _f[1];
    var _g = React.useState(), direction = _g[0], setDirection = _g[1];
    var isStepping = Boolean(nextItem || prevItem);
    var toggleNext = React.useCallback(function (next) {
        if (!isStepping) {
            setDirection(AnimationDirection.NEXT);
            setNextItem(next);
            var lastTime_1;
            requestAnimationFrame(function animation(time) {
                if (!lastTime_1)
                    lastTime_1 = time;
                if (time - lastTime_1 < speed) {
                    requestAnimationFrame(animation);
                    return;
                }
                setDirection(undefined);
                setHistory(history.concat(currentItem));
                setCurrentItem(next);
                setNextItem(undefined);
            });
        }
    }, [currentItem, history, isStepping, speed]);
    var toggleBack = React.useCallback(function () {
        if (!isStepping) {
            var prevPage_1 = history[history.length - 1];
            if (prevPage_1) {
                setDirection(AnimationDirection.PREV);
                setPrevItem(prevPage_1);
                var lastTime_2;
                requestAnimationFrame(function animation(time) {
                    if (!lastTime_2)
                        lastTime_2 = time;
                    if (time - lastTime_2 < speed) {
                        requestAnimationFrame(animation);
                        return;
                    }
                    setDirection(undefined);
                    setCurrentItem(prevPage_1);
                    setPrevItem(undefined);
                    setHistory(history.slice(0, -1));
                });
            }
        }
    }, [history, isStepping, speed]);
    return (React.createElement(ContentStepperWrapper, __assign({}, props),
        React.createElement(ContentPages, { "$direction": direction, "$speed": speed },
            React.createElement(exports.ContentStepperContext.Provider, { value: { toggleBack: toggleBack, toggleNext: toggleNext } },
                React.createElement(SlidePage, null, prevItem),
                React.createElement(SlidePage, null, currentItem),
                React.createElement(SlidePage, null, nextItem)))));
};
exports.default = ContentStepper;
var templateObject_1, templateObject_2, templateObject_3;
